module.exports = __webpack_public_path__ + "media/images/flags/br-f1b8e364a7dd0a8f3fb51316f7cac573.svg";